import styled from 'styled-components'

export const FadeCarouselWrapper = styled.div`
  position: relative;
  min-height: 550px;
`

export const FadeCarouselItem = styled.div`
  transition: opacity ${props => props.speed}ms;
  opacity: 0;
  z-index: 0;

  &.selected {
    opacity: 1;
    z-index: 1;
  }
`

export const FadeCarouselDotContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 65%;
  transform: translateX(-50%);
  width: fit-content;
  padding: 0.25rem;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5;

  & > *:not(:last-child) {
    margin-right: 0.5rem;
  }

  @media only screen and (max-width: 700px) {
    left: 50%;
    bottom: -5%;
  }
`

export const FadeCarouselDot = styled.button`
  background: var(--light);
  width: 12px;
  height: 12px;
  border: 2px solid var(--orange2);
  border-radius: 50%;

  &.selected {
    background: var(--orange2);
    pointer-events: none;
  }
`
